import { render, staticRenderFns } from "./ZalTypeModal.vue?vue&type=template&id=06e0cb9b&"
import script from "./ZalTypeModal.vue?vue&type=script&lang=js&"
export * from "./ZalTypeModal.vue?vue&type=script&lang=js&"
import style0 from "./ZalTypeModal.vue?vue&type=style&index=0&id=06e0cb9b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports